export default __webpack_public_path__ + "static/media/icon-profile-img.0cb56966.png";